import type { JobPostingProduct } from '../entitlement/entitlement'
import { initialState } from '..'
import { SET, Actions } from '../../actions/packages/packages'

import type { SiteAlias, WebshopPackage } from '../../../schema/webshop-package'

export type Upgrade = {
  features: Array<string>,
  name: string,
  productCode?: string,
  requiredFeatures: Array<string>,
  requiredSites: Array<SiteAlias>,
  sites?: Array<SiteAlias>,
}

type Suggestible = {
  productCode: string,
  name: string,
  price: number,
  descriptions: Array<string>,
  listImage?: string,
}

export type JobPostingPackage = Suggestible & {
  jobPosting: JobPostingProduct,
  upgrades?: Array<Upgrade>,
}

export type UpgradesPackage = Suggestible & {
  upgrades: Array<Upgrade>,
}

export type PackagesStoreType = {
  suggestiblePackages: Array<WebshopPackage>,
}

const reducer = (state: PackagesStoreType, { type, payload }: Actions): PackagesStoreType => {
  if (!state) return initialState.packages

  switch (type) {
    case SET:
      return {
        suggestiblePackages: payload,
      }
    default:
      return state
  }
}

export default reducer
